import React from 'react';
import Select from '../../ui/Select';

export { default as OnboardingModal } from './OnboardingModal';
export { default as FileDropzone, FileList, formatFileSize } from './FileDropzone';
export { default as OnboardingAlert } from './OnboardingAlert';

export const WizardSelect = (props) => <Select classPrefix="ob-select" portal={false} {...props} />;
